import React from 'react';
import PropTypes from 'prop-types';

export default function NotFound({ message, statusCode }) {
  return (
    <div className="not-found">
      <h2 className="not-found__title">
        {statusCode}: {message}
      </h2>
      <h3 className="not-found__subtitle">Please enjoy these suggestions:</h3>
    </div>
  );
}

NotFound.defaultProps = {
  message: 'the page you are looking for cannot be found',
  statusCode: 404
};

NotFound.propTypes = {
  message: PropTypes.string,
  statusCode: PropTypes.number
};



// WEBPACK FOOTER //
// ./src/views/components/not_found_component/not_found_component.js